export const detectHttpsMode = () =>
  window && window.location ? window.location.protocol === 'https:' : false;

export default detectHttpsMode;



// WEBPACK FOOTER //
// ./src/common/utils/detectHttpsMode.js